import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

export type BtnType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  public loading = input(false);
  public disabled = input(false);
  public label = input<string | undefined>(undefined);
  public ariaLabel = input<string | undefined>(undefined);
  public iconClass = input<string | undefined>(undefined);
  public btnClass = input<string>(
    'btn btn-falcon-default btn-sm d-flex align-items-center gap-2'
  );
  public type = input<BtnType>('button');
  public clicked = output<MouseEvent>();

  handleClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.disabled() || this.loading()) return;
    this.clicked.emit(event);
  }
}
